import { render, staticRenderFns } from "./ContactsRegionsTable.vue?vue&type=template&id=2dec97bc&scoped=true"
import script from "./ContactsRegionsTable.vue?vue&type=script&lang=js"
export * from "./ContactsRegionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec97bc",
  null
  
)

export default component.exports